(function ($) {
	'use strict';

	$(function () {
		const mobileQuery = window.matchMedia('(max-width: 767px)');

		function syncFooterAccordion() {
			$('.site-footer').each(function () {
				const $footer = $(this);

				if (mobileQuery.matches) {
					$footer.find('.js-footer-accordion-item').each(function () {
						const $item = $(this);
						const isOpen = $item.hasClass('is-open');
						$item.find('.js-footer-accordion-content').toggle(isOpen);
						$item.find('.js-footer-accordion-toggle').attr('aria-expanded', isOpen ? 'true' : 'false');
					});
				} else {
					$footer.find('.js-footer-accordion-content').show();
					$footer.find('.js-footer-accordion-toggle').attr('aria-expanded', 'true');
				}
			});
		}

		$(document).on('click', '.js-footer-accordion-toggle', function () {
			if (!mobileQuery.matches) return;

			const $item = $(this).closest('.js-footer-accordion-item');
			const isOpen = !$item.hasClass('is-open');

			$item.toggleClass('is-open', isOpen);
			$(this).attr('aria-expanded', isOpen ? 'true' : 'false');
			$item.find('.js-footer-accordion-content').stop(true, true).slideToggle(200);
		});

		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener('change', syncFooterAccordion);
		} else if (mobileQuery.addListener) {
			mobileQuery.addListener(syncFooterAccordion);
		}

		syncFooterAccordion();
	});
})(jQuery);
